/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Task } from './task';


export interface TaskResultResponse { 
    /**
     * the total number of results
     */
    count: number;
    result: Array<Task>;
}

